import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

export default function Pagination(theme) {
  const isLight = theme.palette.mode === 'light';
  const isMobile = theme.breakpoints.down('sm');

  const rootStyle = (ownerState) => {
    const outlinedVariant = ownerState.variant === 'outlined';

    const softVariant = ownerState.variant === 'soft';

    const defaultStyle = {
      '& .MuiPaginationItem-root': {
        ...(outlinedVariant && {
          borderColor: alpha(theme.palette.grey[500], 0.32),
        }),
        '&.Mui-selected': {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        ...(softVariant && {
          '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
              color: theme.palette[color][isLight ? 'dark' : 'light'],
              backgroundColor: alpha(theme.palette[color].main, 0.16),
              '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.32),
              },
            },
          },
        }),
      }),
    }));

    return [...colorStyle, defaultStyle];
  };

  return {
    MuiPagination: {
      defaultProps: {
        color: 'primary',
        siblingCount: 1,
        boundaryCount: 1,

        sx: {
          [isMobile]: {
            '& .MuiPagination-ul': {
              flexWrap: 'nowrap',
            },
          },
          // Abaixo de 375px reduz ainda mais
          '@media (max-width: 375px)': {
            '& .MuiPagination-ul': {
              flexWrap: 'nowrap',
            },
          },
        },
      },

      styleOverrides: {
        root: ({ ownerState }) => ({
          ...rootStyle(ownerState),
          '& .MuiPaginationItem-previousNext': {
            minWidth: '32px',
            padding: '0 6px',
          },
          '@media (max-width: 375px)': {
            '& .MuiPaginationItem-root': {
              minWidth: '28px',
              height: '28px',
              fontSize: '0.75rem',
              padding: '0 4px',
            },
            '& .MuiPaginationItem-previousNext': {
              minWidth: '26px',
              padding: '0 4px',
            },
          },
        }),
        ul: {
          gap: '0px',
          '& > li': {
            margin: '0',
          },
        },
      },
    },
  };
}
